export function toApiAcceptedDateFormat(dateString) {
  if (dateString === null || dateString.length === 0) {
    return null;
  }

  let date = new Date(dateString);

  let y = date.getFullYear();
  let m = date.getMonth() + 1;
  let d = date.getDate();

  let padM = m < 10 ? '0' + m : m;
  let padD = d < 10 ? '0' + d : d;

  return [y, padM, padD].join('-');
}



// WEBPACK FOOTER //
// ./client/app/shared/payload.utils.js